import { INormalizedOutboxMessage, IOutboxMessage } from "./outbox-message";

export function createOutboxMessage<T extends IOutboxMessage = IOutboxMessage>(
  title: string,
  pluginId: string,
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any = null
): T {
  return { title, data, pluginId } as T;
}

export function normalizeOutboxMessage(message: IOutboxMessage): INormalizedOutboxMessage {
  return {
    event_name: message.title,
    event_data: message.data,
  };
}
